import { render, staticRenderFns } from "./AthletesLoad.vue?vue&type=template&id=59af8a54&"
import script from "./AthletesLoad.vue?vue&type=script&lang=js&"
export * from "./AthletesLoad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports